import { Table, TableBody, TableContainer } from '@mui/material'
import SearchInPageInput from '../../../components/SearchInPage';
import { SectionWrapper, Row } from '../../../components/tableComponents';
import { asset, IAssets } from '../../../types/snapshot'
import CustomizedAccordion from '../../../components/AccordionComponent';
import { useContext } from 'react';
import { LabContext } from '../../../context/lab';
import { getExplorerLink } from '../../../utils/utils';

type props = {
    snapshotAssets: IAssets
}

const CurveDataView = ({snapshotAssets} : props) => {
    type row = {title: string, value: string};
    const keys: string[] = Object.keys(snapshotAssets);
    const rows = keys.reduce(
        (validRows, key,) => {
            if(typeof snapshotAssets[key as keyof IAssets] === "string")
                validRows.push({title: key, value: snapshotAssets[key as keyof IAssets] as string}); 
            return validRows;
        }
    ,[] as row[]);
    return <TableContainer>
        <Table  aria-label="snapshot curve data assets table">
            <TableBody>
                {rows.map((row) => <Row field={row.title} value={row.value} key={row.value}/>)}
            </TableBody>
        </Table>
    </TableContainer>
}

const Assets = ({assets} : {assets: asset[]}) => {
    const {lab} = useContext(LabContext);
    
    return (
        <TableBody>
            {assets.map((row) => {
                const link: string = getExplorerLink(row.symbol, row.address, !!lab?.isMain)
                
                return <Row field={row.symbol} hasCopyOption value={row.address} route={link.length? link : undefined} key={row.address+row.symbol}/>
            })}
        </TableBody>
    );
};
        
const SnapshotAssetsView = ({snapshotAssets} : props) => {
    return (
        <>
            <SearchInPageInput />
                <CustomizedAccordion summary='Curve Data' >
                    <CurveDataView snapshotAssets={snapshotAssets} />
                </CustomizedAccordion>
                <CustomizedAccordion summary='Assets' isExpanded={true} >
                    <SectionWrapper mt={0} mb={0}>
                        <Table  aria-label="snapshot assets table">
                            <Assets assets={snapshotAssets.assets} />
                        </Table>
                    </SectionWrapper>
                </CustomizedAccordion>
        </>
    );
}

export default SnapshotAssetsView;

